module.exports = __webpack_public_path__ + "img/bus_bell-off.3aa76b2f.svg";